export const TOGGLE_LOADING = 'contact/attachment/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'contact/attachment/TOGGLE_SUCCESS'
export const GET_ATTACHMENT = 'contact/attachment/GET_ATTACHMENT'
export const SET_ATTACHMENTS = 'contact/attachment/SET_ATTACHMENTS'
export const CREATE_ATTACHMENT = 'contact/attachment/CREATE_ATTACHMENT'
export const SET_CREATED_ATTACHMENT = 'contact/attachment/SET_CREATED_ATTACHMENT'
export const EDIT_ATTACHMENT = 'contact/attachment/EDIT_ATTACHMENT'
export const SET_EDITED_ATTACHMENT = 'contact/attachment/SET_EDITED_ATTACHMENT'
export const DELETE_ATTACHMENT = 'contact/attachment/DELETE_ATTACHMENT'
export const SET_DELETED_ATTACHMENT = 'contact/attachment/SET_DELETED_ATTACHMENT'
export const SET_PERMISSIONS = 'contact/attachment/SET_PERMISSIONS'
export const GET_HISTORY = 'contact/attachment/GET_HISTORY'
export const SET_HISTORY = 'contact/attachment/SET_HISTORY'
export const CLEAR_HISTORY = 'contact/attachment/CLEAR_HISTORY'
export const RESET_ATTACHMENTS = 'contact/attachment/RESET_ATTACHMENTS'
